Bingo.RegistrySelectDateModal = {};
Bingo.RegistrySelectDateModal.init = function () {
    $('.js__book-registry--select-date-modal').on('submit', function () {
        if (!Nette.validateForm(this)) {
            return false;
        }

        const $this = $(this);

        const data = $this.serializeArray().reduce((obj, item) => {
            obj[item.name] = item.value;
            return obj;
        }, {});

        $.nette.ajax({
            url: $this.attr('action'),
            type: 'POST',
            data,
            success() {
                $this.closest('.modal').modal('hide');
            },
        });

        return false;
    });
};
